import { api } from "@/services/api";
import { FormControl, FormLabel } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import Select from "react-select";
import { AddButton } from "./AddButton";
import { FieldError } from "@/components/FieldError";

import { FieldError as Error } from "react-hook-form";

interface Props {
  isInvalid: boolean;
  error?: Error;
  value: string;
  onChange: (value: string) => void;
}

export interface OptionType {
  label: string;
  value: string;
}

export function FieldFilial({
  isInvalid,
  value: _value,
  onChange,
  error,
  ...rest
}: Props) {
  const { data: options, isLoading } = useQuery({
    queryKey: ["filial-select"],
    queryFn: () => api.get("filial"),
    select: (response: any) =>
      response.data?.map(
        ({
          id,
          nomefantasia,
        }: {
          id: string;
          nomefantasia: string;
        }): OptionType => ({
          value: String(id),
          label: nomefantasia,
        })
      ),
  });

  const value: OptionType = React.useMemo(() => {
    const selected = options?.filter(
      (option: OptionType) => option.value == _value
    );
    if (!options || !selected) {
      return { value: _value, label: "" };
    }
    return (selected || {}) as unknown as OptionType;
  }, [options, _value]);


  return (
    <FormControl isInvalid={isInvalid}>
      <FormLabel mb="0.40rem">
        Filial
        <AddButton />
      </FormLabel>

      <Select
        {...rest}
        isLoading={isLoading}
        isClearable={true}
        isSearchable={true}
        options={options}
        value={value}
        placeholder="Selecione"
        onChange={(newValue) => onChange(newValue?.value || "")}
      />

      <FieldError error={error} />
    </FormControl>
  );
}
